import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { IVehicle } from "@app/interfaces/IVehicle";
import { DrivingStylesService } from "../driving-styles.service";
import './driving-style-vehicle-preview.component.scss';

@Component({
    selector: 'driving-style-vehicle-preview',
    template: require('./driving-style-vehicle-preview.component.html')
})
export class DrivingStyleVehiclePreviewComponent implements OnInit, OnChanges {

    @Input() vehicle: IVehicle;

    loading: boolean;

    constructor(
        private readonly drivingStylesService: DrivingStylesService
    ) {

    }

    ngOnInit() {
        this.render();
    }

    ngOnChanges() {
        this.render();
    }

    //--

    private async render(): Promise<void> {

        if (!this.vehicle) {
            return;
        }

        this.loading = true;

        if (!this.vehicle.drivingStyle) {
            this.vehicle.drivingStyle = await this.drivingStylesService.getDrivingStyleForVehicle(this.vehicle.Id);
        }

        this.loading = false;
    }
}
